
 <!-- <div class="content-wrapper pt-2"> -->
  <!-- Main content -->
  <section class="content">
   
    <!-- Default box -->
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Bike Rent</div> 
      <form  [formGroup] ="form"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <fieldset>
      <div class="card-body">

        <div class="row">

        <div class="form-group">
          <input  name="id" readonly formControlName="id"  id="id"  class="form-control"    type="hidden">
          </div>

        <div class="col-md-4">
            <div class="form-group">
            <label for="rentId" class="col-form-label">Rent Id</label>  
            <div class="input-group">
                <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
            </div>
            <input   [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="rentId" placeholder="Rent Id"  class="form-control field-bg-color" [class.is-invalid]="formErrors.rentId" (blur)="logValidationErrors()"   type="text">
                </div>
                <span class="text-danger" *ngIf="formErrors.rentId"><small>{{formErrors.rentId}}</small> </span>   
            </div>
          </div>

          <input readonly formControlName="personId"  class="form-control"    type="hidden">

          <div class="col-md-4">        
            <div class="form-group">
            <label for="personName" class="col-form-label ">Person Name</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input  [ngClass]="{'dark-input-field' : isDark }" (focusout)="getCustomerDetails()"  [matAutocomplete]="autoCustomer" formControlName="personName" placeholder="Person Name"  class="form-control field-bg-color" [class.is-invalid]="formErrors.personName" (blur)="logValidationErrors()"  type="text">
            <mat-autocomplete autoActiveFirstOption  #autoCustomer="matAutocomplete">
                <mat-option *ngFor="let option of filteredCustomerList | async" [value]="option.GuestName">
                  {{option.GuestName}}
                </mat-option>
              </mat-autocomplete> 
        </div>
          <span class="text-danger" *ngIf="formErrors.personName"><small>{{formErrors.personName}}</small> </span>   
           </div>      
        </div>

        <div class="col-md-4">
        <div class="form-group">
            <label for="vehicleNo" class="col-form-label ">Vehicle No</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
            </div>
            <select (change)="getVehicleData($event.target)" [ngClass]="{'dark-input-field' : isDark }" formControlName="vehicleNo" class="form-control field-bg-color"   [class.is-invalid]="formErrors.vehicleNo" (blur)="logValidationErrors()">        
                <option [ngValue]="null">-Select-</option>
                <option *ngFor="let item of vehicleList" [value]="item.VehicleNo">
                  {{item.VehicleNo}}
                </option>
            </select>
              </div>
              <span class="text-danger" *ngIf="formErrors.vehicleNo"><small>{{formErrors.vehicleNo}}</small> </span>   
        </div>
        </div>  

    </div>

    
    <div class="row">   

        <div class="col-md-4">        
            <div class="form-group">
            <label for="brand" class="col-form-label ">Brand</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input readonly  [ngClass]="{'dark-input-field' : isDark }" formControlName="brand" placeholder="Brand"  class="form-control field-bg-color" [class.is-invalid]="formErrors.brand" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.brand"><small>{{formErrors.brand}}</small> </span>   
           </div>      
        </div>

        <div class="col-md-4">        
            <div class="form-group">
            <label for="model" class="col-form-label ">Model</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input readonly  [ngClass]="{'dark-input-field' : isDark }" formControlName="model" placeholder="Model"  class="form-control field-bg-color"  type="text">
          </div>
           </div>      
        </div>

        <div class="col-md-4">        
            <div class="form-group">
            <label for="color" class="col-form-label ">Color</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input readonly  [ngClass]="{'dark-input-field' : isDark }" formControlName="color" placeholder="Color"  class="form-control field-bg-color"  type="text">
          </div>
           </div>      
        </div>

        </div>

        <div class="row">   
        
        <div class="col-md-4">
          <div class="form-group">
            <label for="dateStart" class="col-form-label ">DateStart</label>  
            <div class="input-group">
                <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="dateStart" class="form-control field-bg-color"  [class.is-invalid]="formErrors.dateStart" (blur)="logValidationErrors()" placeholder="Date Start">
            </div>
            <span class="text-danger" *ngIf="formErrors.dateStart"><small>{{formErrors.dateStart}}</small> </span>   
            </div>
         </div>

         
        <div class="col-md-4">        
            <div class="form-group">
            <label for="kmStart" class="col-form-label ">Km Start</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input (keyup)="calculateAmounts()"   [ngClass]="{'dark-input-field' : isDark }" formControlName="kmStart" placeholder="Km Start"  class="form-control field-bg-color"  [class.is-invalid]="formErrors.kmStart" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.kmStart"><small>{{formErrors.kmStart}}</small> </span>   
           </div>      
        </div>

        </div>

    <div class="row">  
  
        <div class="col-md-4">
            <div class="form-group">
            <label for="dateFinish" class="col-form-label ">Date Finish</label>  
            <div class="input-group">
                <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="dateFinish" class="form-control field-bg-color"  placeholder="Date Finish">
            </div>
            </div>
        </div>
        
        <div class="col-md-4">
            <div class="form-group">
            <label for="kmFinish" class="col-form-label ">Km Finish</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input (keyup)="calculateAmounts()"  [ngClass]="{'dark-input-field' : isDark }" formControlName="kmFinish" placeholder="Km Finish" class="form-control"  type="text">
          </div>
           </div>
        </div>

    </div>

        <div class="row">  

            <div class="col-md-4">        
                <div class="form-group">
               <label for="totalMiles" class="col-form-label ">Total Miles</label>  
               <div class="input-group">
                 <div class="input-group-prepend">
               <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
               </div>
               <input  readonly [ngClass]="{'dark-input-field' : isDark }" formControlName="totalMiles" placeholder="Total Miles"  class="form-control field-bg-color"  type="text">
             </div>
              </div>
              </div>

        <div class="col-md-4">        
            <div class="form-group">
           <label for="reason" class="col-form-label ">Reason</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input   [ngClass]="{'dark-input-field' : isDark }" formControlName="reason" placeholder="Reason"  class="form-control" [class.is-invalid]="formErrors.reason" (blur)="logValidationErrors()"  type="text">
         </div>
         <span class="text-danger" *ngIf="formErrors.reason"><small>{{formErrors.reason}}</small> </span>   
          </div>
          </div>

          
          <div class="col-md-4">        
            <div class="form-group">
           <label for="income" class="col-form-label ">Income</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input  [ngClass]="{'dark-input-field' : isDark }" formControlName="income" placeholder="Income"  class="form-control"  type="text">
         </div>
          </div>
          </div>

       </div>

       <div class="row">  

        <div class="col-md-4">        
            <div class="form-group">
           <label for="expense" class="col-form-label ">Expense</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input   [ngClass]="{'dark-input-field' : isDark }" formControlName="expense" placeholder="Expense"  class="form-control"  type="text">
         </div>
          </div>
          </div>

    <div class="col-md-4">        
        <div class="form-group">
       <label for="mainBillRef" class="col-form-label ">Main Bill Ref.</label>  
       <div class="input-group">
         <div class="input-group-prepend">
       <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
       </div>
       <input  [ngClass]="{'dark-input-field' : isDark }" formControlName="mainBillRef" placeholder="Main Bill Ref."  class="form-control"  type="text">
     </div>
      </div>
      </div>

      
      <div class="col-md-4">        
        <div class="form-group">
       <label for="remarks" class="col-form-label ">Remarks</label>  
       <div class="input-group">
         <div class="input-group-prepend">
       <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
       </div>
       <input  [ngClass]="{'dark-input-field' : isDark }" formControlName="remarks" placeholder="Remarks"  class="form-control"  type="text">
     </div>
      </div>
      </div>

   </div>


      </div>                                
      <!-- /.card-body -->
      <div class="card-footer">
        <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

        <button *ngIf="crud_access.create"  type="submit" [disabled]="isSaveBtnDisabled" class="btn btn-primary ml-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Save
        </button>

        <button class="btn btn-primary ml-2" routerLink="../bike-rent-list"><i class="fa fa-table p-1"></i>Bike Rent List</button>
        <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
      </div>
      <!-- /.card-footer-->
    </fieldset>
      </form>
    </div>
  </section>
    <!-- </div> -->


    <!-- Form Values : {{ addCustomerForm.value | json }} -->
  
